export function isEmptyArray(array: unknown): boolean {
	if (!Array.isArray(array)) {
		return false;
	}

	return array.length === 0;
}
